import { Preferences } from "@capacitor/preferences"

export const appStorage = Preferences
